import { useState } from "react";
import { Link } from "react-router-dom";
import FigureCard from "@/components/feature/FigureCard";
import {
  figures,
  figureCategories,
  type FigureCategory,
} from "@/mocks/figures";

export default function FigureWall() {
  const [active, setActive] = useState<string>("all");

  const list =
    active === "all"
      ? figures
      : figures.filter((f) => f.category === active);

  return (
    <section className="border-y border-background-200 bg-background-100">
      <div className="mx-auto max-w-6xl scroll-mt-24 px-4 py-12 md:px-6 md:py-16">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-end lg:justify-between">
          <div>
            <p className="text-xs font-semibold tracking-widest text-secondary-700">
              ARCHIVE
            </p>
            <h2 className="mt-1 font-display text-2xl font-bold text-foreground-950 md:text-3xl">
              人物档案库
            </h2>
            <p className="mt-2 max-w-xl text-sm text-foreground-600">
              以角色视角归档每一个浮出的新面孔、新涉事者与新当事人，按「举报、主角、关联、进展」四类持续补充。
            </p>
          </div>
          <Link
            to="/renwu"
            className="inline-flex w-fit shrink-0 items-center gap-1 whitespace-nowrap text-sm font-semibold text-primary-700 hover:text-primary-600"
          >
            查看全部档案
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="mt-6 flex flex-wrap gap-2">
          {figureCategories.map((c: FigureCategory) => (
            <button
              key={c.key}
              type="button"
              onClick={() => setActive(c.key)}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                active === c.key
                  ? "bg-foreground-950 text-background-50"
                  : "bg-background-50 text-foreground-700 hover:bg-secondary-200"
              }`}
            >
              {c.label}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((f) => (
            <FigureCard key={f.id} figure={f} />
          ))}
        </div>
      </div>
    </section>
  );
}